import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui'

@Injectable({
  providedIn: 'root',
})
export class DetsisBirimPopupService {
  errorResponse: any = {};

  constructor(
    private dataCoreService: DataCoreService
  ) {}

  
  getDetsisIletisimData(detsisNo: number): Promise<any> {
    const dataSource = this.dataCoreService.getOData('GenDetsisIletisim');
    const filterArr = [];
    filterArr.push(['DetsisNo', '=', detsisNo]);
    dataSource.filter(filterArr);
    return dataSource.load().then();
  }

  getGenBirimData(detsisNo: number): Promise<any> {
    const dataSource = this.dataCoreService.getOData('GenBirim');
    const filterArr = [];
    filterArr.push(['KimlikNo', '=', detsisNo]);
    dataSource.filter(filterArr);
    return dataSource.load().then();
  }

  insertGenBirim(data: any): Promise<any> {
    return this.dataCoreService.createDataStore('GenBirim', data);
  }

  updateGenBirim(data: any): Promise<any> {
    return this.dataCoreService.updateDataStore('GenBirim', data);
  }

  deleteGenBirim(data: any): Promise<any> {
    return this.dataCoreService.removeDataStore('GenBirim', data);
  }
}
